module.exports = __webpack_public_path__ + "wildlifecompliance_vue/img/satellite_icon.34f7eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/satellite_icon.png
// module id = 795
// module chunks = 0